import { PlanState } from "./UserPlanState";
export class UserDataPlanTools {
    /**
     * Builds the plan state of the given user.
     * @param user The user.
     */
    static getPlanState(user) {
        const expiredPlans = [];
        const activePlans = [];
        user.roles.forEach((x) => {
            const nowTime = new Date();
            const today = new Date(nowTime.getFullYear(), nowTime.getMonth(), nowTime.getDate());
            const nextYear = new Date(nowTime.getFullYear() + 1, nowTime.getMonth(), nowTime.getDate());
            // if there is no last day, assume next year.
            if (x.organization.lastPlan == null) {
                // cannot check the plan\
                console.error("could not check plans, no data");
                return;
            }
            if (x.organization.lastPlan.firstDay != null) {
                x.organization.lastPlan.firstDay = new Date(x.organization.lastPlan.firstDay);
            }
            if (x.organization.lastPlan.lastDay != null) {
                x.organization.lastPlan.lastDay = new Date(x.organization.lastPlan.lastDay);
            }
            const lastDay = x.organization.lastPlan.lastDay ?? nextYear;
            if (lastDay.getFullYear() < today.getFullYear()) {
                // the plan is expired.
                expiredPlans.push(x.organization.lastPlan);
                return;
            }
            if (lastDay.getFullYear() == today.getFullYear() &&
                lastDay.getMonth() < today.getMonth()) {
                // the plan is expired.
                expiredPlans.push(x.organization.lastPlan);
                return;
            }
            if (lastDay.getFullYear() == today.getFullYear() &&
                lastDay.getMonth() == today.getMonth() &&
                lastDay.getDate() < today.getDate()) {
                // the plan is expired.
                expiredPlans.push(x.organization.lastPlan);
                return;
            }
            activePlans.push(x.organization.lastPlan);
        });
        return new PlanState(expiredPlans, activePlans);
    }
}
